<template>
  <div id="app" class="back">
    <v-app id="inspire" color="primary">
      <v-navigation-drawer v-model="drawer" app width="350">
        <v-list dense>
          <v-list-item link to="/" v-if="!$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/homeFeed" v-if="$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/profile" v-if="$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-account-settings-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Meu Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/alunoHome" class="text-uppercase"
            v-if="$store.getters.isAuthenticated && $store.getters.userLogged.profile != null && $store.getters.userLogged.profile.professor != null">
            <v-list-item-action>
              <v-icon>mdi-weather-sunset-up</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Meu dia
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/noticias" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-newspaper-variant-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Notícias
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/calendar"
            v-if="$store.getters.isAuthenticated && $store.getters.userLogged.profile != null && $store.getters.userLogged.profile.professor != null"
            class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-clipboard-list-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Planilha
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link to="/alunoResumo"
            v-if="$store.getters.isAuthenticated && $store.getters.userLogged.profile != null" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Resumo
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item link to="/chartPageAluno" class="text-uppercase"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleClient 
                && !$store.getters.userLogged.roleAdmin && $store.getters.myTotalTreinoCount > 10">
              <v-list-item-action>
                <v-icon>mdi-chart-pie</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>
                  Gráficos
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

          <v-list-group v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleProfessor" sub-group
            no-action>
            <template v-slot:activator>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Menu do Treinador</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link to="/meusAlunos" class="pl-6 text-uppercase">
              <v-list-item-action>
                <v-icon>mdi-account-group</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Meus Alunos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/treinosDodia" class="pl-6 text-uppercase">
              <v-list-item-action>
                <v-icon>mdi-clipboard-list-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Treinos do dia</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/givenFeedbacks" class="pl-6 text-uppercase">
              <v-list-item-action>
                <v-icon>mdi-chat-processing-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Feedbacks
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>


          <v-list-group v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin" sub-group
            no-action>
            <template v-slot:activator>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Menu do Administrador</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link to="/dailyResume" class="pl-6 text-uppercase">
              <v-list-item-action>
                <v-icon>mdi-calendar-arrow-right</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Resumo do dia</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/admin/treinos" class="pl-6 text-uppercase">
              <v-list-item-action>
                <v-icon>mdi-clipboard-list-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Todos os Treinos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/alunos" class="pl-6 text-uppercase d-none d-sm-flex"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Alunos</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item link to="/reports" class="pl-6 text-uppercase d-none d-sm-flex"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-chart-bar</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>
                  Relatórios
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/chartPageAdmin" class="pl-6 text-uppercase"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-chart-pie</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>
                  Gráficos
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/globalInsights" class="pl-6 text-uppercase"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-magnify</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>
                  Insights Globais
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/specificInsights" class="pl-6 text-uppercase"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-magnify-scan</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>
                  Insights Específicos
                  <span v-if="showNovo" class="ml-2 badge badge-success" :style="novoStyle">novo</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
            

            <v-list-item link to="/users" class="pl-6 text-uppercase d-none d-sm-flex"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Usuários</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/planos" class="pl-6 text-uppercase d-none d-sm-flex"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-notebook-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Planos de Assinatura</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/assinatura" class="pl-6 text-uppercase d-none d-sm-flex"
              v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleAdmin">
              <v-list-item-action>
                <v-icon>mdi-ticket-account</v-icon>
              </v-list-item-action>
              <v-list-item-content class="text-uppercase">
                <v-list-item-title>Assinaturas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

          </v-list-group>

          <v-list-item link to="/removerConta" v-if="$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-trash-can</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Apagar minha Conta
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link @click="logout" v-show="$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                Logout
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="!$store.getters.isAuthenticated"></v-divider>

          <v-list-item link to="/login" v-if="!$store.getters.isAuthenticated" class="text-uppercase">
            <v-list-item-action>
              <v-icon>mdi-login</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>

      <!-- <v-app-bar app color="primary" dark :src="backgroundToolBar"> -->
      <v-app-bar app color="primary darken-1" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title class="body-2 font-weight-black" v-if="$store.getters.isAuthenticated">
          <span class="text-uppercase">{{headerTitle}}</span>
        </v-toolbar-title>
        <v-toolbar-title class="subtitle" v-if="!$store.getters.isAuthenticated && headerTitle != null">
          {{headerTitle}}
        </v-toolbar-title>
        <v-toolbar-title class="subtitle"
          v-if="!$store.getters.isAuthenticated && (headerTitle == null || headerTitle == '')">
          <div class="d-sm-flex d-none">T4 Sports :: Plataforma de Treinos</div>
          <div class="d-sm-none d-flex">T4 Sports App</div>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn to="/login" flat v-if="!$store.getters.isAuthenticated" class="d-none d-md-flex">
          Login
        </v-btn>

        <v-menu class="" offset-y v-if="$store.getters.isAuthenticated">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="px-4 mr-0" large v-bind="attrs" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list dense>

            <v-list-item link @click="changeMyPassword = true">
              <v-list-item-title>Alterar Senha</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item @click="logout">
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-content>

        <v-container class="align-stretch justify-space-around" fluid>

          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-container>
      </v-content>
      <v-bottom-navigation app fixed grow color="primary" class="primary darken-3 white--text pb-3 d-sm-none d-flex"
        dark>
        <v-btn to="/homeFeed" v-if="$store.getters.isAuthenticated" small>
          feed
          <v-icon>mdi-view-list-outline</v-icon>
        </v-btn>
        <v-btn small to="/noticias">
          notícias
          <v-icon>mdi-newspaper-variant-outline</v-icon>
        </v-btn>

        <v-btn small to="/alunoHome"
          v-if="$store.getters.isAuthenticated && $store.getters.userLogged.profile != null && $store.getters.userLogged.profile.professor != null">
          hoje
          <v-icon>mdi-calendar</v-icon>
        </v-btn>
        <v-btn small to="/login" v-if="!$store.getters.isAuthenticated">
          login
          <v-icon>mdi-login</v-icon>
        </v-btn>
        <v-btn small to="/calendar"
          v-if="$store.getters.userLogged.profile != null && $store.getters.userLogged.profile.professor != null">
          planilha
          <v-icon>mdi-clipboard-list-outline</v-icon>
        </v-btn>
        <v-btn small to="/alunoResumo"
          v-if="$store.getters.userLogged.profile != null && $store.getters.userLogged.profile.professor != null">
          resumo
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>

        <v-btn small to="/treinosDodia"
          v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleProfessor">
          hoje
          <v-icon>mdi-clipboard-list-outline</v-icon>
        </v-btn>
        <v-btn small to="/meusAlunos" v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleProfessor">
          alunos
          <v-icon>mdi-account-group</v-icon>
        </v-btn>
        <v-btn small to="/meusAlunosResumo"
          v-if="$store.getters.isAuthenticated && $store.getters.userLogged.roleProfessor">
          resumo
          <v-icon>mdi-chart-bar</v-icon>
        </v-btn>

        <!-- <v-btn value="favorites" to="/gravarTreino" v-if="$store.getters.isAuthenticated">
      <v-icon>mdi-record-circle-outline</v-icon>
    </v-btn> -->
      </v-bottom-navigation>

      <!-- loader -->
      <div class="text-center">
        <v-dialog v-model="$store.getters.dialogLoaderMain" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text class="pt-5">
              espera um pouquinho...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <!-- snackbar for global notifications -->
      <v-snackbar class="title" top :timeout="4000" v-model="SnackBar.showSnack">
        <v-row class="text-center">
          <v-col class="body-2">
            {{SnackBar.snackText}}
          </v-col>
        </v-row>
      </v-snackbar>

      <!-- recuperar senha, modal -->
      <v-dialog persistent transition="dialog-bottom-transition" v-model="$store.getters.dialogRecoverPwd" width="500">
        <v-card :disabled="$store.getters.dialogLoaderMain">
          <v-toolbar color="primary" class="pr-1">
            <v-toolbar-title class="text-white">
              Recuperar Senha
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="white">mdi-key-chain-variant</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-text-field class="mb-5 mt-5" clearable color="primary" v-model="emailRecoverPwd"
              prepend-icon="mdi-email-outline" id="email" label="Email de Cadastro" placeholder="Entre com seu email"
              maxlength="150" @click:clear="errorMessageMail = null"
              :error-messages="$v.emailRecoverPwd.$invalid ? ['Digite um email válido'] : []">
            </v-text-field>
          </v-card-text>
          <v-card-actions class="">
            <v-btn text color="primary" @click="closeDialogRecoverPassword">Fechar</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" :disabled="$v.emailRecoverPwd.$invalid"
              @click="sendRecoverMessage">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- recuperar senha, result -->
      <v-dialog persistent transition="dialog-bottom-transition" v-model="dialogRecoverSent" width="500">
        <v-card :disabled="$store.getters.dialogLoaderMain">
          <v-toolbar color="primary" class="pr-1">
            <v-toolbar-title class="text-white">
              Recuperar Senha
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="white">mdi-key-chain-variant</v-icon>
          </v-toolbar>
          <v-card-text class="pa-4">

            <div class="body-1 text-justify pa-5">
              Caso o seu email esteja em nosso sistema, as instruções de recuperação serão enviadas para este endereço.
              Verifique seu email.
            </div>

          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogRecoverSent = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- change pwd -->
      <v-dialog transition="dialog-bottom-transition" width="450" v-if="$store.getters.isAuthenticated"
        v-model="changeMyPassword">
        <v-card :disabled="$store.getters.dialogLoaderMain">
          <v-toolbar color="primary" class="pr-0">
            <v-toolbar-title>
              Redefinir Senha
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon>mdi-key-chain-variant</v-icon>
          </v-toolbar>
          <v-card-text class="pa-5">
            <v-text-field class="mb-5" variant="outlined" v-model="newPwd" id="newPwd" label="Senha" maxlength="20"
              :type="show1 ? 'text' : 'password'" :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="show1 = !show1" counter
              :error-messages="$v.newPwd.$invalid ? ['Digite a senha'] : []">
            </v-text-field>

            <v-text-field class="mb-5" variant="outlined" :disabled="$v.newPwd.$invalid" v-model="confirmNewPwd"
              id="confirmNewPwd" label="Confirme a Senha" maxlength="20" :type="show2 ? 'text' : 'password'"
              :append-inner-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="show2 = !show2" counter
              :error-messages="$v.confirmNewPwd.$invalid ? ['Confirme a senha'] : []">
            </v-text-field>

          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="px-4" large text @click="changeMyPassword = false">
              Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn prepend-icon="mdi-check" class="px-4" large text color="primary"
              :disabled="$v.confirmNewPwd.$invalid" @click="updatePwd">
              Atualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-app>
  </div>

</template>

<script>

import router from "./router/router.js";
import SnackBar from './snackbar';

import HOST from './ws'

import { required, minLength, email, maxLength, sameAs } from 'vuelidate/lib/validators';

export default {

  router,

  props: {
    source: String
  },
  data: () => ({

    SnackBar : SnackBar,

    drawer: false,
    headerTitle : '',

    //imagens de background:
    backgroundToolBar : require('./assets/images/toolbar_background.png'),
    t4icon : require('./assets/icon.png'),

    //total de treinos agendados:
    countTreinos : 0,

    dialogRecoverPwd : false,
    emailRecoverPwd : '',
    dialogRecoverSent : false,

    changeMyPassword : false,
    newPwd : null,
    confirmNewPwd : null,

    show1 : false,
    show2 : false,    

  }),

  computed : {

    dialogLoaderMain : {

      set(value) {
        this.$store.commit("setLoader", value);
      },

      get() {
        return this.$store.state.showMenu;
      }
    },
    showNovo() {
      const deadline = new Date('2024-11-01');
      const today = new Date();
      return today <= deadline;
    },
    novoStyle() {
      return {
        color: '#ff4081', // Customize color (pink accent in Vuetify)
        'font-weight': 'bold', // Bold for emphasis
        'background-color': '#ffe9f0', // Light pink background for extra emphasis
        padding: '2px 6px', // Some padding for a better look
        'border-radius': '4px' // Optional: rounding the edges
      };
    }
  },

  watch: {
    '$route' (to) {
      document.title = to.meta.title || ':: T4 ::';
      this.headerTitle = to.meta.title;
    },
    immediate: true
  },
  mounted (){

    
  },
  methods : {

    updatePwd(){

      console.log('change pwd');

      this.$store.commit("setLoader", true);
      this.axios({
        method: 'post',
        url : HOST.HOST + '/user/atualizasenha', 
        headers: {
          'Content-Type' : 'application/json',
          Authorization: `Bearer ${this.$store.state.currentToken}`},           
          data: {
            id : this.$store.getters.userLogged.id,
            novaSenha : this.newPwd,
          }
      })
      .then(response => {
        console.log('result : ' + response.status);
        this.$store.commit("setLoader", false);
        this.SnackBar.snackText = "Senha atualizada";
        this.SnackBar.showSnack = true;
        this.changeMyPassword = false;
        this.newPwd = null;
        this.confirmNewPwd = null;
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.logout();
      });
    },  

    closeDialogRecoverPassword(){
      this.$store.commit("setDialogRecoverPwd", false);
    },  

    sendRecoverMessage(){

      this.$store.commit("setLoader", true);
      // this.dialogRecoverSent = true;
      // this.$store.commit("setLoader", false);
      this.axios({
        method: "post",
        url: HOST.HOST + "/user/resetsenha",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        params: {
          email : this.emailRecoverPwd,
        }
      }).then(response => {
        console.log('recover pwd, result : ' + response.status);
        this.$store.commit("setLoader", false);
        this.$store.commit("setDialogRecoverPwd", false);
        this.dialogRecoverSent = true;
        this.emailRecoverPwd = null;
        //this.$router.push("/");
        //this.reloadUserData();
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("setDialogRecoverPwd", false);
        this.dialogRecoverSent = true;
        this.emailRecoverPwd = null;
      });
    },

    logout(){
        this.headerTitle = '';

        var storage = window.localStorage;
        storage.removeItem('username');
        storage.removeItem('password');

        this.$store.commit('logout');
        this.$router.push("/");
      },
  },

  validations: {
    emailRecoverPwd : {
      required, email, 
      min: minLength(6),
      max: maxLength(150),
    },
    newPwd: {
      required,
      min: minLength(6)
    },
    confirmNewPwd: {
      required,
      min: minLength(6),
      sameAsPassword: sameAs('newPwd')
    },
    
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.back {
  background-color: #a4b9a6;
  //background-image: url('./assets/images/tobias_run_back_low.jpg');
  //background-size: cover;
  //background-repeat: no-repeat;
}
#inspire {
  background: none;
}

.text-white{
  color: white;
}

.multi-line {
  white-space: pre-line;
}
</style>